import React, { forwardRef, HTMLAttributes } from 'react';
import type { UniqueIdentifier } from '@dnd-kit/core';
import classNames from 'classnames';

import styles from './Page.module.css';
import { Grid } from '@mui/material';
import { ItemType, SelectedFacilityType } from '../types';
import { TenantValueType } from '..';

export enum Position {
  Before = -1,
  After = 1,
}

export enum Layout {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
  Grid = 'grid',
}

export interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'id'> {
  active?: boolean;
  clone?: boolean;
  insertPosition?: Position;
  id: UniqueIdentifier;
  index?: number;
  layout: Layout;
  item: ItemType;
  pinComponentHandler: (id: string) => void;
  selectedValueFacility?: string;
  facilityIds?: string;
  locationIds?: string;
  currentTenant: TenantValueType | undefined
}

export const Page = forwardRef<HTMLDivElement, Props>(function Page(
  { id, index, active, clone, insertPosition, layout, style, item, ...props },
  ref
) {
  const { Component: { Component, ...gridSizes }, pin, ...itemRest } = item;
  return (
    <Grid
      item
      sx={{ width: "100%", display: 'flex', alignItems: 'center', gap: 1, ...style }}
      // style={style}
      className={classNames(
        styles.Wrapper,
        active && styles.active,
        clone && styles.clone,
        insertPosition === Position.Before && styles.insertBefore,
        insertPosition === Position.After && styles.insertAfter,
        // layout === Layout.Vertical && styles.vertical
      )}
      ref={!item?.pin ? ref : null}
      {...gridSizes}
    >
      <Component id={itemRest?.id} index={0} {...props} pin={item?.pin || false} />
    </Grid >
  );
});
